/* Change activity assignee */
export const FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST = 'BULK_ACTIVITY_REASSIGN_USERS_REQUEST';
export const FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST_SUCCESS = 'BULK_ACTIVITY_REASSIGN_USERS_REQUEST_SUCCESS';
export const FETCH_BULK_ACTIVITY_REASSIGN_USERS_REQUEST_ERROR = 'BULK_ACTIVITY_REASSIGN_USERS_REQUEST_ERROR';

export const CHANGE_ACTIVITY_REASSIGN_ERROR = 'CHANGE_ACTIVITY_REASSIGN_ERROR';

export const REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST = 'REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST';
export const REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_SUCCESS = 'REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_SUCCESS';
export const REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_ERROR = 'REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_ERROR';

export const VALIDATE_CHANGE_ACTIVITY_ASSIGNEE = 'VALIDATE_CHANGE_ACTIVITY_ASSIGNEE';
export const VALIDATE_CHANGE_ACTIVITY_ASSIGNEE_SUCCESS = 'VALIDATE_CHANGE_ACTIVITY_ASSIGNEE_SUCCESS';
export const VALIDATE_CHANGE_ACTIVITY_ASSIGNEE_ERROR = 'VALIDATE_CHANGE_ACTIVITY_ASSIGNEE_ERROR';

export const BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST = 'BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST';
export const BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_SUCCESS = 'BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_SUCCESS';
export const BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_ERROR = 'BULK_REASSIGN_ACTIVITY_FROM_VIEWS_REQUEST_ERROR';

export const SET_VALIDATION_ERROR_MESSAGE = 'SET_VALIDATION_ERROR_MESSAGE';
export const CLEAR_VALIDATION_ERROR_MESSAGE = 'CLEAR_VALIDATION_ERROR_MESSAGE';

//TOAST Box reducers
export const SHOW_TOAST_WITH_PROPS = 'SHOW_TOAST_WITH_PROPS';
export const HIDE_TOAST = 'HIDE_TOAST';